module.exports = __webpack_public_path__ + "img/DataEase-white.4e5692d4.png";